import { render, staticRenderFns } from "./community.vue?vue&type=template&id=7e523182&scoped=true"
import script from "./community.vue?vue&type=script&lang=js"
export * from "./community.vue?vue&type=script&lang=js"
import style0 from "./community.vue?vue&type=style&index=0&id=7e523182&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e523182",
  null
  
)

export default component.exports